import React, {useEffect} from 'react'
import Modal from '../../../../../../libs/_fri/components/CustomModal/CustomModal'
import {useListView} from '../../core/ListViewProvider'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../../redux/store'
import {useDeleteUserMutation} from '../../../../../../redux/api/services/user'

export const UserDeleteModal = () => {
  const [deleteUser, {isSuccess, isLoading}] = useDeleteUserMutation()
  const {userIdForDelete, setUserIdForDelete} = useListView()
  const infoState = useSelector((state: RootState) => state.info)

  useEffect(() => {
    if (!isSuccess) return

    setUserIdForDelete(undefined)
  }, [isSuccess])

  return (
    <Modal
      handleClose={() => {
        setUserIdForDelete(undefined)
      }}
      handleConfirm={() => {
        if (!userIdForDelete) return

        const requestData = {
          info: infoState,
          requestContent: {
            id: userIdForDelete,
          },
        }
        deleteUser(requestData)
      }}
      variant='danger'
      size='md'
      isLoading={isLoading}
    >
      <div className='d-flex flex-column text-center'>
        <span className='fs-2x text-primary-dark fw-semibold'>Eliminar usuario</span>
        <span className='text-gray fs-2'>
          ¿Estas seguro que deseas eliminar este usuario?
          {/* {userForDelete?.title} */}
        </span>
      </div>
    </Modal>
  )
}
